import React, { Component } from 'react';

// import logo1 from 'assets/images/logo/switzerland.png';
// import logo2 from 'assets/images/logo/eurail.png';

import i18n from 'i18n-react';
import { StorageHandler, BackImage } from 'C4';
import { storageKeys } from 'settings';
import logo from 'assets/images/logo/logo_caymankind.png';
import { HashLink as Link } from 'react-router-hash-link';

export default class RewardsView extends Component {
  render() {
    const params = new URLSearchParams(window.location.search);
    let mobile = false;
    if (params.get('mobile')) {
      mobile = true;
    }
  
    return (
      <div className="contentContainer BookingForm">
        <BackImage />
        <div className="header">
        {mobile &&
            <img src={logo} alt="Logo" className="logo" />
          }
          {!mobile && <Link to="/main">
            <img src={logo} alt="Logo" className="logo" />
          </Link>}
          <h3>{i18n.translate('rewards.bookingForm.title')}</h3>
        </div>
        <hr />
        <div className="bodyRewards">
          <img src="https://front.travpromobile.com/883/final-header.png" alt="sidebar" />
          <h1>Earn cash rewards for your Cayman Islands bookings.*</h1>
          <div className="holder">
            <p>
              <b>Monthly Grand Prize</b><br />
          $500 for the travel advisor booking the highest number of guests to the Cayman Islands.
              <br /><br />
              <b>Monthly First Runner-Up</b><br />
          $250 for the travel advisor booking the next-highest number of guests to the Cayman Islands.
              <br /><br />
              <b>Monthly Second Runner-Up</b><br />
          $100 for the travel advisor booking the next-highest number of guests to the Cayman Islands.
              <br /><br />
              <b>1 Monthly Winner Chosen at Random</b><br />
          $100 for one randomly selected travel advisor with qualifying bookings of guests to the Cayman Islands.
              <br /><br />            
              {/* <a 
                href="https://nam11.safelinks.protection.outlook.com/ap/b-59584e83/?url=https%3A%2F%2Fcaymanislands-my.sharepoint.com%2F%3Ab%3A%2Fg%2Fpersonal%2Fdtaugher_caymanislands_ky%2FETooYoi1YcpKl4C_Hl027FEBhp0M5rddCBy7VKW1shK1KA%3Fe%3D81bteY&data=05%7C01%7Cansley%40travpromobile.com%7C6299c6377c624268079108dbbad1973e%7Cbb394109578a484496c78ec98fb16688%7C0%7C0%7C638309181606079614%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=AMsnYr7tyeu6GTqIj%2F5z%2FKcprnTrmTs5I0lV4OUUmwo%3D&reserved=0"
                target="_blank" 
                className="btn-copy"
              >
                  Checkout Previous Winners Here &gt;
              </a>
              <br /><br />      */}
          *Bookings entered are valid only after client&apos;s travel is completed.
              <br /><br />
              {mobile && <span>See program <Link className="terms" to="/main/rewards/terms?mobile=true">Terms & Conditions</Link> for details.</span>}
              {!mobile && <span>See program <Link className="terms" to="/main/rewards/terms">Terms & Conditions</Link> for details.</span>}
            </p>
          </div>
          <div className="buttonHolder">
            {mobile && <Link to="/main/rewards/form?mobile=true">
              <button type="button" className="btn">
                {i18n.translate('rewards.bookingForm.button')}
              </button>
            </Link>}
            {!mobile && <Link to="/main/rewards/form">
            <button type="button" className="btn">
              {i18n.translate('rewards.bookingForm.button')}
            </button>
          </Link>}
          </div>
        </div>
        {mobile && (
          <style>
          {
            '\
      .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }'
          }
        </style>
        )}
      </div>
    );
  }
}
